import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { addBlog, getBlogCategories } from "store/actions";
import { useNavigate } from "react-router-dom";
import { getId } from "helpers/functions";
import ImageUploadEn from "./ImageUploadEn";
import JoditEditor from "components/shared/JoditEditor";

const AddBlog = () => {
  const [selectedMainImage, setSelectedMainImage] = useState();
  const [description, setDescription] = useState({ ar: "", en: "" });
  // eslint-disable-next-line no-unused-vars
  const [tags, setTags] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { locale } = useIntl();

  const { blogCategories } = useSelector((state) => state.blogCategories);

  useEffect(() => {
    dispatch(getBlogCategories());
  }, [dispatch]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const renderCategoriesOptions = blogCategories?.map((category) => (
    <option value={getId(category)}>{category?.title?.[locale]}</option>
  ));

  const onSubmit = async (data) => {
    try {
      if (selectedMainImage) data.image = selectedMainImage.path;
      // data.images = additionalImages.length
      //   ? additionalImages?.filter((imageObj) => !!imageObj?.file?.path)
      //     .map((imageObj) => imageObj?.file?.path) : [];
      data.description = description;
      data.tags = tags;
      await dispatch(addBlog({ data, navigate }));
    } catch (error) {
      console.error("Error submitting blog:", error);
    }
  };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id="addBlog" />
            </h4>
          </div>
          <div className="card-body form-group settings-tabs">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  {/* Main Image Upload */}
                  <Col lg={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="image" />
                      </h5>
                      <ImageUploadEn
                        selectedImageEn={selectedMainImage}
                        setSelectedImageEn={setSelectedMainImage}
                        accept="image/*"
                      />
                    </div>
                  </Col>

                  {/* Category Select */}
                  <Col xs={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="category" />
                      </h5>
                      <div>
                        <select
                          style={{
                            backgroundPosition: "left 0.70rem center",
                          }}
                          className="form-control form-select"
                          {...register("category", {
                            required: true,
                          })}
                        >
                          <option value="">اختر التصنيف</option>
                          {renderCategoriesOptions}
                        </select>
                      </div>
                      <p className="error-hint">
                        {errors.category?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>

                  {/* Title Inputs */}
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="title" />{" "}
                        <FormattedMessage id="arabic-language" />
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("title.ar", {
                          required: true,
                        })}
                      />
                      <p className="error-hint">
                        {errors.title?.ar?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="title" />{" "}
                        <FormattedMessage id="english-language" />
                      </h5>
                      <input
                        type="text"
                        className="form-control"
                        {...register("title.en", {
                          required: true,
                        })}
                      />
                      <p className="error-hint">
                        {errors.title?.en?.type === "required" && (
                          <FormattedMessage id="required" />
                        )}
                      </p>
                    </div>
                  </Col>

                  {/* Description Editors */}
                  {/* Description Editors */}
                  <Col md={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" /> (AR)
                      </h5>
                      <JoditEditor
                        value={description.ar}
                        placeholder="اكتب هنا..."
                        onChange={(newContent) =>
                          setDescription((prev) => ({
                            ...prev,
                            ar: newContent,
                          }))
                        }
                      />
                    </div>
                    <p className="error-hint">
                      {errors.description?.ar?.type === "required" && (
                        <FormattedMessage id="required" />
                      )}
                    </p>
                  </Col>

                  <Col md={12}>
                    <div className="form-group required">
                      <h5>
                        <FormattedMessage id="description" /> (EN)
                      </h5>
                      <JoditEditor
                        value={description.en}
                        placeholder="Start typing..."
                        onChange={(newContent) =>
                          setDescription((prev) => ({
                            ...prev,
                            en: newContent,
                          }))
                        }
                      />
                    </div>
                    <p className="error-hint">
                      {errors.description?.en?.type === "required" && (
                        <FormattedMessage id="required" />
                      )}
                    </p>
                  </Col>
                </Row>
                <div className="seo-data">
                  <h3 className="mb-3">
                    <FormattedMessage id="seoData" />
                  </h3>
                  <Row>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>
                          <FormattedMessage id="title" /> (
                          <FormattedMessage id="arabic" />)
                        </h5>
                        <div>
                          <input
                            type="text"
                            className="form-control form-outline"
                            {...register("seo.title.ar")}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>
                          <FormattedMessage id="title" /> (
                          <FormattedMessage id="english" />)
                        </h5>
                        <div>
                          <input
                            type="text"
                            className="form-control form-outline"
                            {...register("seo.title.en")}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>
                          <FormattedMessage id="description" /> (
                          <FormattedMessage id="arabic" />)
                        </h5>
                        <div>
                          <textarea
                            className="form-control form-outline"
                            {...register("seo.description.ar")}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} xs={12}>
                      <div className="form-group  ">
                        <h5>
                          <FormattedMessage id="description" /> (
                          <FormattedMessage id="english" />)
                        </h5>
                        <div>
                          <textarea
                            className="form-control form-outline"
                            {...register("seo.description.en")}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>

              {/* Submit Button */}
              <Col lg={4}>
                <div className="form-group mt-3">
                  <button type="submit" className="btn btn-blue">
                    <FormattedMessage id="add" />
                  </button>
                </div>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBlog;
